import {createContext, useContext} from 'react';

export const ApparatusContext = createContext({
    apparatus: [],
    loading: true,
    // Set when the apparatus listener errors and we have no usable data.
    error: false,
    // True until the server has confirmed the snapshot. A cache-only snapshot
    // (offline / blocked listen channel) can report an empty `apparatus` that is
    // NOT authoritative — consumers must not treat it as "no apparatus".
    fromCache: true
});

export const useApparatus = () => useContext(ApparatusContext);
